import React, {FC, ReactElement} from 'react';

import {
  ControllerRenderProps,
  ControllerFieldState,
  UseFormStateReturn,
  UseControllerProps,
  Controller,
} from 'react-hook-form';

type FieldValues = Record<string, string>;

type RenderFunction = ({
  field,
  fieldState,
  formState,
}: {
  field: ControllerRenderProps<FieldValues, string>;
  fieldState: ControllerFieldState;
  formState: UseFormStateReturn<FieldValues>;
}) => React.ReactElement;

type AurFormControllerProps = {
  children?: React.ReactNode;
  render?: RenderFunction;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
} & UseControllerProps<FieldValues>;

export const AurFormController: FC<AurFormControllerProps> = (props) => {
  const {
    children,
    render: controllerRender,
    onChange: handleOnChange,
    onBlur: onInputBlur,
    ...rest
  } = props;

  const nbhControllerRender: RenderFunction = ({
    field: {value, onChange, ref, onBlur},
    fieldState: {error, invalid},
  }) => (
    <>
      {React.cloneElement(React.Children.only(children) as ReactElement, {
        value: value,
        onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
          onChange(event);
          if (handleOnChange) handleOnChange(event);
        },
        onBlur: () => {
          onBlur();
          onInputBlur?.();
        },
        ref: ref,
        error: invalid,
        helperText: error?.message,
        ...rest,
      })}
    </>
  );

  return (
    <Controller
      render={controllerRender ?? nbhControllerRender}
      defaultValue=""
      {...rest}
    />
  );
};
